module.exports = __webpack_public_path__ + "static/16-3c6cea0cef478591aaef76e79c0bdda7.jpg";